import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { API_URL as API } from '@/utils/apiConfig';

const AffiliateContext = createContext(null);

export function AffiliateProvider({ children }) {
  const [affiliate, setAffiliate] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/affiliate/auth/me`, { withCredentials: true });
      setAffiliate(res.data);
    } catch {
      setAffiliate(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/affiliate/auth/login`, { email, password }, { withCredentials: true });
    if (res.data.requires_2fa) {
      return res.data; // { requires_2fa: true, pending_token: ... }
    }
    setAffiliate(res.data);
    return res.data;
  };

  const verify2FA = async (pendingToken, code) => {
    const res = await axios.post(`${API}/affiliate/auth/verify-2fa`, { pending_token: pendingToken, code }, { withCredentials: true });
    setAffiliate(res.data);
    return res.data;
  };

  const logout = useCallback(async () => {
    try { await axios.post(`${API}/affiliate/auth/logout`, {}, { withCredentials: true }); } catch {}
    setAffiliate(null);
  }, []);

  return (
    <AffiliateContext.Provider value={{ affiliate, loading, login, verify2FA, logout, checkAuth }}>
      {children}
    </AffiliateContext.Provider>
  );
}

export function useAffiliate() {
  const ctx = useContext(AffiliateContext);
  if (!ctx) throw new Error('useAffiliate must be used within AffiliateProvider');
  return ctx;
}
